var _g, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 260,
    viewBox: "0 0 261 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_936_5175)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.2086,
    y: 36,
    width: 180,
    height: 180,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.7086,
    y: 36.5,
    width: 179,
    height: 179,
    rx: 31.5,
    stroke: "#D9D9D9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.979 75.5938H157.348C160.042 75.5938 162.658 76.0234 165.196 76.9219C168.867 78.25 172.186 80.5938 174.685 83.6406C177.223 86.6875 178.902 90.4375 179.487 94.3438C179.722 95.7891 179.761 97.2344 179.761 98.6797V152.703C179.761 154.422 179.683 156.18 179.331 157.859C178.55 161.727 176.715 165.359 174.06 168.289C171.444 171.219 168.008 173.406 164.298 174.578C162.033 175.281 159.691 175.594 157.309 175.594C156.254 175.594 101.823 175.594 101.003 175.555C97.0197 175.359 93.0759 174.07 89.7569 171.844C86.516 169.656 83.8608 166.609 82.1427 163.094C80.6589 160.086 79.917 156.727 79.917 153.367V97.8203C79.8389 94.5 80.5418 91.2188 81.9865 88.25C83.6655 84.7344 86.2817 81.6484 89.5226 79.4609C92.8416 77.1953 96.7464 75.8672 100.729 75.6719C101.12 75.5938 101.549 75.5938 101.979 75.5938Z",
    fill: "url(#paint0_linear_936_5175)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M164.103 157.391C163.751 156.844 163.361 156.297 162.931 155.789C161.955 154.617 160.823 153.602 159.573 152.742C158.011 151.688 156.176 151.023 154.302 150.945C152.974 150.867 151.647 151.102 150.397 151.57C149.148 152 147.937 152.625 146.766 153.25C145.399 153.953 144.032 154.656 142.588 155.242C140.87 155.945 139.073 156.492 137.238 156.883C134.934 157.312 132.592 157.469 130.288 157.43C126.11 157.352 121.932 156.727 117.949 155.555C114.435 154.5 111.077 153.055 107.914 151.219C105.141 149.617 102.564 147.781 100.143 145.711C98.152 143.992 96.3168 142.156 94.5987 140.203C93.4273 138.836 92.2949 137.391 91.2406 135.906C90.8111 135.32 90.4206 134.695 90.0692 134.07L79.7607 122.938V97.7422C79.7607 85.5156 89.6397 75.5938 101.861 75.5938H121.58L136.184 90.4375C169.14 112.859 158.48 137.586 158.48 137.586C158.48 137.586 167.851 148.133 164.103 157.391Z",
    fill: "url(#paint1_linear_936_5175)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M136.262 90.4375C169.218 112.859 158.558 137.586 158.558 137.586C158.558 137.586 167.929 148.172 164.142 157.43C164.142 157.43 160.276 150.945 153.794 150.945C147.547 150.945 143.876 157.43 131.303 157.43C103.306 157.43 90.0692 134.031 90.0692 134.031C115.294 150.633 132.513 138.875 132.513 138.875C121.151 132.273 96.9806 100.711 96.9806 100.711C118.027 118.641 127.125 123.367 127.125 123.367C121.697 118.875 106.469 96.9219 106.469 96.9219C118.652 109.266 142.861 126.492 142.861 126.492C149.733 107.43 136.262 90.4375 136.262 90.4375Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_936_5175",
    x: 0.208618,
    y: 0,
    width: 260,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0367917 0 0 0 0 0.0348958 0 0 0 0 0.0484375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_936_5175"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_936_5175",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_936_5175",
    x1: 139.226,
    y1: 72.0254,
    x2: 120.326,
    y2: 179.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAE42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF3E31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_936_5175",
    x1: 130.761,
    y1: 77.2094,
    x2: 116.928,
    y2: 155.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E39F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D33929"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwift);
export default __webpack_public_path__ + "static/media/swift.16b2f76e4637f018cd787f1a7dd15a61.svg";
export { ForwardRef as ReactComponent };